"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldGovernmentAdvisor = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
const SpaceType_1 = require("../../SpaceType");
const SilverCubeHandler_1 = require("../../community/SilverCubeHandler");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const Eris_1 = require("../ares/Eris");
const Phase_1 = require("../../Phase");
const TileType_1 = require("../../TileType");
class WorldGovernmentAdvisor extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.WORLD_GOVERNMENT_ADVISOR,
            tags: [Tags_1.Tags.EARTH],
            tr: { tr: 2 },
            metadata: {
                cardNumber: 'P67',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tr(2).cards(1);
                    b.preludeBox('action', (ce) => {
                        ce.vSpace();
                        ce.action('Raise 1 global parameter WITHOUT GETTING ANY TR OR OTHER BONUSES.', (eb) => {
                            eb.empty().startAction.oceans(1, Size_1.Size.SMALL).slash().oxygen(1, Size_1.Size.SMALL).slash().temperature(1, Size_1.Size.SMALL).slash().venus(1, Size_1.Size.SMALL).nbsp(Size_1.Size.TINY).asterix();
                        });
                    });
                }),
                description: 'Raise your TR 2 steps. Draw 1 card.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        ;
        player.increaseTerraformRatingSteps(2);
        player.drawCard();
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        game.phase = Phase_1.Phase.SOLAR;
        const action = new OrOptions_1.OrOptions();
        action.title = 'Select action for World Government Terraforming';
        action.buttonLabel = 'Confirm';
        if (game.gameOptions.silverCubeVariant === true) {
            SilverCubeHandler_1.SilverCubeHandler.addSilverCubeWGTOptions(player, game, action);
        }
        else {
            if (game.getTemperature() < constants_1.MAX_TEMPERATURE) {
                action.options.push(new SelectOption_1.SelectOption('Increase temperature', 'Increase', () => {
                    game.increaseTemperature(player, 1);
                    game.log('${0} acted as World Government and increased temperature', (b) => b.player(player));
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
            if (game.getOxygenLevel() < constants_1.MAX_OXYGEN_LEVEL) {
                action.options.push(new SelectOption_1.SelectOption('Increase oxygen', 'Increase', () => {
                    game.increaseOxygenLevel(player, 1);
                    game.log('${0} acted as World Government and increased oxygen level', (b) => b.player(player));
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
            if (game.canAddOcean()) {
                action.options.push(new SelectSpace_1.SelectSpace('Add an ocean', game.board.getAvailableSpacesForOcean(player), TileType_1.TileType.OCEAN, (space) => {
                    game.addOceanTile(player, space.id, SpaceType_1.SpaceType.OCEAN);
                    game.log('${0} acted as World Government and placed an ocean', (b) => b.player(player));
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
            if (game.getVenusScaleLevel() < constants_1.MAX_VENUS_SCALE && game.gameOptions.venusNextExtension) {
                action.options.push(new SelectOption_1.SelectOption('Increase Venus scale', 'Increase', () => {
                    game.increaseVenusScaleLevel(player, 1);
                    game.log('${0} acted as World Government and increased Venus scale', (b) => b.player(player));
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
        }
        if (game.gameOptions.aresExtension && game.gameOptions.aresExtremeVariant && game.isSoloMode()) {
            const unprotectedHazardSpaces = Eris_1.Eris.getAllUnprotectedHazardSpaces(game);
            if (unprotectedHazardSpaces.length > 0) {
                action.options.push(new SelectSpace_1.SelectSpace('Remove an unprotected hazard', Eris_1.Eris.getAllUnprotectedHazardSpaces(game), TileType_1.TileType.DUST_STORM_MILD, (space) => {
                    space.tile = undefined;
                    game.log('${0} acted as World Government and removed a hazard tile', (b) => b.player(player));
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
        }
        MoonExpansion_1.MoonExpansion.ifMoon(game, (moonData) => {
            if (moonData.colonyRate < constants_1.MAXIMUM_COLONY_RATE) {
                action.options.push(new SelectOption_1.SelectOption('Increase the Moon colony rate', 'Increase', () => {
                    MoonExpansion_1.MoonExpansion.raiseColonyRate(player, 1);
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
            if (moonData.miningRate < constants_1.MAXIMUM_MINING_RATE) {
                action.options.push(new SelectOption_1.SelectOption('Increase the Moon mining rate', 'Increase', () => {
                    MoonExpansion_1.MoonExpansion.raiseMiningRate(player, 1);
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
            if (moonData.logisticRate < constants_1.MAXIMUM_LOGISTICS_RATE) {
                action.options.push(new SelectOption_1.SelectOption('Increase the Moon logistics rate', 'Increase', () => {
                    MoonExpansion_1.MoonExpansion.raiseLogisticRate(player, 1);
                    game.phase = Phase_1.Phase.ACTION;
                    return undefined;
                }));
            }
        });
        if (action.options.length === 0) {
            game.phase = Phase_1.Phase.ACTION;
            return undefined;
        }
        return action;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, TRIncrease: 2 });
    }
}
exports.WorldGovernmentAdvisor = WorldGovernmentAdvisor;
//# sourceMappingURL=WorldGovernmentAdvisor.js.map